import { call, put, select, takeEvery } from 'redux-saga/effects';
import {
  DeleteNewDealerCart,
  getNewDealerCart,
  INewDealerRequestCart,
  newDealerActionCreators,
  NewDealerActionKeys
} from '../';
import { IState } from '../..';
import { IEntityWithMessages } from '../../../services/HttpService';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { processMessages, showFailedRequestDialog } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';
import * as api from '../newDealerApi';

function* deleteNewDealerCartSaga(action: DeleteNewDealerCart) {
  yield put(uiActionCreators.showSpinnerDialog());

  const cart: INewDealerRequestCart = yield select((state: IState) =>
    getNewDealerCart(state, action.payload.newDealerRequestId, action.payload.brand)
  );

  if (cart) {
    const response: IApiExecuteRespone<IEntityWithMessages<number>> = yield call(api.deleteNewDealerCart, cart.cartId);

    if (!response.requestFailed && response.value) {
      yield processMessages(response.value);

      if (response.value.value) {
        yield put(newDealerActionCreators.removeCart(action.payload));
      }
    } else {
      yield showFailedRequestDialog(response);
    }
  }

  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchDeleteNewDealerCart() {
  yield takeEvery(NewDealerActionKeys.DELETE_NEW_DEALER_CART, deleteNewDealerCartSaga);
}
